import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { catchError, Observable, switchMap, throwError } from 'rxjs';
import { ApiResponseService } from './api-response.service';
import { AlertService } from 'src/app/module-executor/services/alert/alert.service';

@Injectable({ providedIn: 'root' })
export class ApiResponseInterceptor implements HttpInterceptor {

  constructor( private authService: ApiResponseService, private alertService: AlertService ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const authToken = this.authService.getToken();
    let clonedRequest = req;
    if (authToken && !req.headers.has('Authorization')) {
      clonedRequest = req.clone({
        setHeaders: {
          Authorization: `Bearer ${authToken}`,
        }
      });
    }
    return next.handle(clonedRequest).pipe(
      catchError((error: HttpErrorResponse) => {
        this.alertService.showApiError({ error });
        // return next.handle(clonedRequest);
        return throwError(() => error);
      })
    );
  }
}
